import React, { useState } from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import HeaderComponent from "../components/Header";
import AccessibilityStatementModal from "../components/AccessibilityStatementModal";

export const ELECTRICITY_PLAN_THANK_YOU_PATH = "/electricity-plan-thank-you";

export function ElectricityPlanThankYou() {
  const [showAccessibility, setShowAccessibility] = useState(false);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
      }}
      dir="rtl"
    >
      <HeaderComponent />

      <AccessibilityStatementModal
        open={showAccessibility}
        onClose={() => setShowAccessibility(false)}
      />

      <Container
        maxWidth="md"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 5, sm: 8 },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: "100%",
            textAlign: "center",
            borderRadius: 3,
            px: { xs: 3, sm: 6 },
            py: { xs: 4, sm: 6 },
            borderTop: "8px solid",
            borderColor: "primary.main",
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            sx={{
              fontWeight: 900,
              color: "text.primary",
              mb: 2.5,
              fontSize: { xs: 30, sm: 38 },
              lineHeight: 1.15,
            }}
          >
            תודה! בקשתך למעבר מסלול התקבלה.
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "text.primary",
              fontWeight: 600,
              lineHeight: 1.55,
              mb: 2,
              fontSize: { xs: 21, sm: 25 },
            }}
          >
            אנחנו מטפלים בבקשה, והמעבר למסלול החדש ייכנס לתוקף בתחילת חודש
            החיוב הבא.
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              fontWeight: 600,
              lineHeight: 1.55,
              fontSize: { xs: 18, sm: 21 },
            }}
          >
            בקשות המוגשות לאחר תחילת החודש ייכנסו לתוקף בתחילת החודש העוקב.
          </Typography>
        </Paper>
      </Container>

      <Box
        component="footer"
        sx={{
          bgcolor: "secondary.main",
          textAlign: "right",
          px: 1,
          py: 0.5,
          width: "100%",
        }}
      >
        <Box
          component="button"
          type="button"
          onClick={() => setShowAccessibility(true)}
          sx={{
            fontSize: "0.98rem",
            color: "secondary.contrastText",
            textDecoration: "underline",
            mr: 0.625,
            bgcolor: "transparent",
            border: 0,
            p: 0,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          הצהרת נגישות
        </Box>
      </Box>
    </Box>
  );
}
